<app-tooltip [tooltip]="tooltip" [disabled]="disableTooltip">
  <div
    class="drop-down-container"
    [class.readOnly]="_readonly()"
    [class.drop-down-container--multiselect-value-overlay]="
      useMultiselectValueOverlay && multiple
    "
  >
    <mat-form-field [attr.readonly]="_readonly()" [attr.disabled]="_disabled()">
      @if (label && !(useMultiselectValueOverlay && multiple) && !hasValue()) {
        <mat-label>{{ label }}</mat-label>
      }
      <mat-select
        #matSelect="matSelect"
        [value]="value()"
        [disabled]="_disabled()"
        [required]="required"
        [multiple]="multiple"
        [compareWith]="compareWith"
        [placeholder]="placeholderOption ?? ''"
        [attr.aria-label]="
          useMultiselectValueOverlay && multiple && label ? label : null
        "
        (selectionChange)="onMatSelectionChange($event.value)"
        (openedChange)="onPanelOpened($event)"
        panelClass="infinite-dropdown-mat-panel"
      >
        <mat-option
          disabled
          class="infinite-dropdown-search-mat-option"
          (click)="$event.stopPropagation()"
        >
          <input
            type="text"
            class="infinite-dropdown-search-input"
            [value]="searchText()"
            (input)="onSearchInput($any($event.target).value)"
            [placeholder]="
              searchPlaceholder || ('core.buttons.search' | transloco)
            "
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
        </mat-option>
        @for (row of displayRows(); track valueAccessor(row)) {
          @if (sectionLabelAccessor(row); as sectionLabel) {
            <mat-option disabled class="infinite-dropdown-section-mat-option">
              {{ sectionLabel }}
            </mat-option>
          }
          <mat-option
            [value]="valueAccessor(row)"
            [matTooltip]="labelAccessor(row)"
            [matTooltipDisabled]="!optionMatTooltip"
            matTooltipPosition="above"
          >
            {{ labelAccessor(row) }}
          </mat-option>
        }
        @if (loading() && displayRows().length === 0) {
          <mat-option disabled class="infinite-dropdown-status-option">
            {{ loadingLabel }}
          </mat-option>
        }
        @if (loadingMore()) {
          <mat-option disabled class="infinite-dropdown-status-option">
            {{ loadingMoreLabel }}
          </mat-option>
        }
        <mat-option disabled class="infinite-dropdown-sentinel-mat-option">
          <span data-infinite-dropdown-sentinel></span>
        </mat-option>
      </mat-select>
      @if (showClearButton()) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          class="drop-down-clear-btn"
          (click)="clearSelection($event)"
          [attr.aria-label]="'Clear selection'"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
    @if (useMultiselectValueOverlay && multiple) {
      <div
        class="infinite-dropdown-multiselect-value-overlay"
        [title]="overlayMultiselectLabelsText()"
        aria-hidden="true"
      >
        {{ overlayMultiselectLabelsText() }}
      </div>
    }
  </div>
</app-tooltip>
